import axios from "axios";
import axiosMockInstance from "../mocks/AxiosMockAdapter";

// eslint-disable-next-line
const axiosLiveInstance = axios.create();
const axiosInstance = axiosMockInstance; // change this to axiosLiveInstance to disable mocking

export default axiosInstance;
